// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

import $ from "jquery";
import "controllers";
import "stimulus";
import "select2"; // globally assign select2 fn to $ element
import "popper.js";
import "bootstrap";
require("@rails/ujs").start();
require("turbolinks").start();
require("@rails/activestorage").start();
require("channels");
require("jquery");
require("turbolinks");
//= require jquery
//= require jquery_ujs
//= require bootstrap.min

// Support component names relative to this directory:
var componentRequireContext = require.context("application/components", true);
var ReactRailsUJS = require("react_ujs");
ReactRailsUJS.useContext(componentRequireContext);
window.React = global.React = require("react");
window.ReactDOM = global.ReactDOM = require("react-dom");
window.$ = $;
